<div class="offer" *ngIf="openedDelivery">
    <div class="summary-container">
        <div id="options">
            <div class="summary-title">
                {{ 'DELIVERY|Dostawa' | translate }}
            </div>
            <section class="details-container">
                <div class="flex-horizontal wrap-conditional">
                    <div class="document-card_data">
                        <span class="document-card_data__label">
                            {{ 'CONTACT|Adres dostawy:' | translate }}
                        </span>
                        <div class="document-card_data__content">
                            <div class="document-card_data__content-box">
                                <span class="document-card_data__content-box__wrapper" *ngIf="client?.delivery">
                                    <span *ngIf="client?.delivery?.addressLine1">{{ client?.delivery?.addressLine1}}<br></span>
                                    <span *ngIf="client?.delivery?.addressLine2">{{ client?.delivery?.addressLine2}}<br></span>
                                    <span *ngIf="client?.delivery?.postalCode">{{ client?.delivery?.postalCode}} </span>
                                    <span *ngIf="client?.delivery?.city">{{ client?.delivery?.city}}<br></span>
                                    <span *ngIf="client?.delivery?.regionId">{{ getRegionName(client?.delivery?.countryId, client?.delivery?.regionId)  }}<br></span>
                                    <span *ngIf="client?.delivery?.countryId">{{ getCountry(client?.delivery?.countryId)?.name }}<br></span>
                                    <span *ngIf="client?.deliveryPhone || client?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ client?.version === 1 ? (client?.deliveryPhone || client?.phoneNumber) : client?.phoneNumber }}<br></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="document-card_data">
                        <span class="document-card_data__label">
                            {{ 'DELIVERY|Kupujący:' | translate }}
                        </span>
                        <div class="document-card_data__content">
                            <div class="document-card_data__content-box">
                                <span class="document-card_data__content-box__wrapper" *ngIf="client">
                                    <b class="document-card_data__content-box__company_name" *ngIf="client?.companyName">{{ client?.companyName }}<br></b>
                                    <b class="document-card_data__content-box__name" *ngIf="!client?.isCompany">{{ client?.firstName }} {{ client?.lastName }}<br></b>
                                    <span *ngIf="client?.isCompany">{{ client?.firstName }} {{ client?.lastName }}<br></span>
                                    <span *ngIf="client?.phoneNumber || client?.registryPhone">{{ 'CONTACT|tel.' | translate }} {{ client?.phoneNumber || client?.registryPhone }}<br></span>
                                    {{ client?.email || client?.registryEmail }}<br>
                                </span>

                                <div class="document-card_data__content-box__actions">
                                    <button iccIconButton appearance="flat" (click)="openClientPreviewDialog()"
                                        *ngIf="!isEmpty(client)"
                                        [title]="'INTERFACE|Podgląd' | translate"
                                    >
                                        <icc-icon name="open"></icc-icon>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="document-actions">
            <div class="document-actions-row">
                <div class="document-actions-bar document-actions-bar__left">
                    <p *ngIf="hasAccessTo.signDelivery">{{ 'DELIVERY|Dostarczono {deliveredCount}/{allCount}' | translate: {deliveredCount: deliveredPositions.size, allCount: positions.length} }}</p>
                </div>

                <div class="document-actions-bar" *ngIf="!loaded"></div>
                <div class="document-actions-bar document-actions-bar__right">
                    <button
                        iccButton
                        [appearance]="openedDelivery.isConfirmed ? 'secondary' : 'primary'"
                        data-test="delivery-sign"
                        *ngIf="hasAccessTo.signDelivery"
                        [disabled]="!changedPositionSelection && !openedDelivery.isConfirmed"
                        (click)="signDelivery()"
                    >
                        <icc-icon [name]="openedDelivery.isConfirmed ? 'done' : 'edit'"></icc-icon>
                        {{ openedDelivery.isConfirmed ? ('DELIVERY|Podpisano' | translate) : ('DELIVERY|Podpisz' | translate) }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="product-elements" *ngIf="positions.length > 0"  >
        <ng-container *ngFor="let position of positions; index as id; trackBy: trackByPosition">
            <icc-sales-document-position
                class="details-card"
                *ngIf="position != null"
                [position]="position"
                [salesPosition]="positionsMap.get(position.uuid)"
                [positionTree]="positionsDetails.get(position.uuid)"
                [showDetails]="positionsShowDetails.get(position.uuid)"
                [positionTitle]="positionsTitles.get(position.uuid)"
                [positionsIndexes]="positionsIndexes"
                [positionsTitles]="positionsTitles"
                [index]="id"
                [sorting]="false"
                [attachments]="[]"
                (showDetailsEvent)="switchShowDetails(position.uuid, $event)"
                [id]="position.uuid"
                (deliveredChange)="updatePositionDeliveryStatus(position, $event)"
                [deliveryConfirmed]="openedDelivery.isConfirmed"
                [hostname]="hostname"
            ></icc-sales-document-position>
        </ng-container>
    </div>

    <div class="position-description">
        <span class="title">{{ 'DELIVERY|Notatka kierowcy' | translate }}</span>

        <div class="icc-card">
            <icc-inplace *ngIf="!openedDelivery.isConfirmed" >
                <ng-template iccTemplate="display">
                    <span *ngIf="openedDelivery.driverNote" class="document-description">{{openedDelivery.driverNote}}</span>
                    <span *ngIf="!openedDelivery.driverNote">{{ 'DELIVERY|Kliknij, aby ustawić notatkę' | translate }}</span>
                </ng-template>
                <ng-template iccTemplate="content">
                    <textarea [ngModel]="openedDelivery.driverNote" (ngModelChange)="changeDriverNote($event)" name="document-description" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus></textarea>
                </ng-template>
            </icc-inplace>

            <p  class="document-description" *ngIf="openedDelivery.isConfirmed">
                {{openedDelivery.driverNote}}
            </p>
        </div>

    </div>

</div>
<div id="sign-container"  *ngIf="signMode" cdkTrapFocus>
    <h4>{{ 'DELIVERY|Potwierdzam odbiór {deliveredCount} z {allCount} pozycji' | translate: {deliveredCount: deliveredPositions.size, allCount: positions.length} }}</h4>
    <div id="signature-pad-wrapper">
        <canvas #signaturePad  id="signature-pad" ></canvas>
    </div>
    <div id="saving-info" *ngIf="saving === true">
        <p>{{ 'INTERFACE|Trwa zapisywanie...'| translate }}</p>
    </div>
    <div id="sign-buttons" *ngIf="!saving === true">
        <button
            iccButton
            appearance="secondary"
            data-test="delivery-sign-confirm"
            (click)="cancelSign()"
            *ngIf="!openedDelivery.isConfirmed"
        >
            <icc-icon name="close"></icc-icon>
            {{ 'INTERFACE|Anuluj' | translate }}
        </button>
        <button
            iccButton
            appearance="secondary"
            data-test="delivery-sign-confirm"
            (click)="clearSign()"
            *ngIf="!openedDelivery.isConfirmed"
        >
            <icc-icon name="delete"></icc-icon>
            {{ 'INTERFACE|Wyczyść' | translate }}
        </button>
        <div class="spacer"></div>
        <button
            iccButton
            appearance="primary"
            data-test="delivery-sign-confirm"
            *ngIf="!openedDelivery.isConfirmed"
            (click)="saveSign()"
        >
            <icc-icon name="done"></icc-icon>
            {{ 'INTERFACE|Zatwierdź' | translate }}
        </button>
        <button
            iccButton
            appearance="secondary"
            data-test="delivery-sign-confirm"
            (click)="cancelSign()"
            *ngIf="openedDelivery.isConfirmed"
        >
            <icc-icon name="close"></icc-icon>
            {{ 'INTERFACE|Zamknij' | translate }}
        </button>
    </div>
</div>